import { resolveSequentially, type WithRef } from '@principle-theorem/shared';
import { D4WCustomMappingsHandler } from './d4w/mappings';
import {
  type ICustomMappingsHandler,
  type IPracticeMigration,
} from '@principle-theorem/practice-migrations/interfaces';
import { PraktikaCustomMappingsHandler } from './praktika/mappings';
import { ExactCustomMappingsHandler } from './exact/mappings';
import { ExactCustomMappingsHandlerV2 } from './exact/mappings-v2';
import { DentrixCustomMappingsHandler } from './dentrix/mappings';
import { CorePracticeCustomMappingsHandler } from './core-practice/mappings';
import { OasisCustomMappingsHandler } from './oasis/mappings';
import { PracticeWorksCustomMappingsHandler } from './practice-works/mappings';

export const RESOURCE_MAPPINGS_HANDLERS: ICustomMappingsHandler[] = [
  new D4WCustomMappingsHandler(),
  new PraktikaCustomMappingsHandler(),
  new ExactCustomMappingsHandler(),
  new ExactCustomMappingsHandlerV2(),
  new DentrixCustomMappingsHandler(),
  new CorePracticeCustomMappingsHandler(),
  new OasisCustomMappingsHandler(),
  new PracticeWorksCustomMappingsHandler(),
];

export function getCustomMappingsHandler(
  migration: WithRef<IPracticeMigration>
): ICustomMappingsHandler | undefined {
  return RESOURCE_MAPPINGS_HANDLERS.find((mappingsHandler) => {
    if (
      mappingsHandler.migrationType !== migration.metadata.name ||
      mappingsHandler.migrationVersion !== migration.metadata.version
    ) {
      return false;
    }
    return mappingsHandler.canHandle(migration.mappings);
  });
}

export async function initialiseCustomMappings(
  migration: WithRef<IPracticeMigration>
): Promise<void> {
  const handler = getCustomMappingsHandler(migration);
  if (!handler) {
    return;
  }

  await handler.addEntities(migration);
}

export async function autocompleteCustomMappings(
  migration: WithRef<IPracticeMigration>
): Promise<void> {
  const handler = getCustomMappingsHandler(migration);
  if (!handler) {
    return;
  }

  await resolveSequentially(handler.mappingHandlers, async (mappingHandler) => {
    if (!mappingHandler.autocompleteMappings) {
      return;
    }
    await mappingHandler.autocompleteMappings(migration);
  });
}
